import { type ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useModalFocus } from './useModalFocus';

/** The menu: slides in from the left over the chat; Escape or a tap outside closes it. */
export function Drawer({
  open,
  onClose,
  label,
  children,
}: {
  open: boolean;
  onClose: () => void;
  label: string;
  children: ReactNode;
}) {
  const panel = useRef<HTMLDivElement>(null);
  useModalFocus(open, panel, onClose);
  if (!open) return null;
  return createPortal(
    <div className="overlay">
      <div className="overlay__frame">
        <div className="overlay__scrim" onClick={onClose} aria-hidden="true" />
        <div className="drawer" role="dialog" aria-modal="true" aria-label={label} ref={panel}>
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
}
